export default __webpack_public_path__ + "static/media/caseSlide5.2df18f07.png";